import { resourceHeaders } from './resource-actions.factory';

/**
 * @typedef {object} IPlanResource
 * @property {() => ng.resource.IResource<import('types/api').V1.SubscriptionPlan>} fetchPlan
 */

export default [
  '$resource',
  PlanResource,
];

/**
 * @return {IPlanResource}
 */
export function PlanResource($resource) {
  return $resource('/api/v1/plans/:id', {}, {
    'fetchPlan': {
      method: 'GET',
      headers: resourceHeaders.get
    }
  });
}